/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CouponId202,
  PutApiV1CouponId400,
  PutApiV1CouponId401,
  PutApiV1CouponId404,
  PutApiV1CouponId409,
  PutApiV1CouponId500,
  PutApiV1CouponIdMutationRequest,
  PutApiV1CouponIdMutationResponse,
  PutApiV1CouponIdPathParams,
} from "../../types/couponRegistroController/PutApiV1CouponId.ts";
import { couponViewModelSchema } from "../couponViewModelSchema.ts";
import { updateCouponRequestViewModelSchema } from "../updateCouponRequestViewModelSchema.ts";

export const putApiV1CouponIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1CouponIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CouponId202Schema = z.lazy(
  () => couponViewModelSchema,
) as unknown as ToZod<PutApiV1CouponId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CouponId400Schema =
  z.any() as unknown as ToZod<PutApiV1CouponId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CouponId401Schema =
  z.any() as unknown as ToZod<PutApiV1CouponId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CouponId404Schema =
  z.any() as unknown as ToZod<PutApiV1CouponId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1CouponId409Schema =
  z.any() as unknown as ToZod<PutApiV1CouponId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CouponId500Schema =
  z.any() as unknown as ToZod<PutApiV1CouponId500>;

export const putApiV1CouponIdMutationRequestSchema = z.lazy(
  () => updateCouponRequestViewModelSchema,
) as unknown as ToZod<PutApiV1CouponIdMutationRequest>;

export const putApiV1CouponIdMutationResponseSchema = z.lazy(
  () => putApiV1CouponId202Schema,
) as unknown as ToZod<PutApiV1CouponIdMutationResponse>;
